import React, { useContext, useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Checkbox } from 'antd';

import { LegalContext } from '../../contexts/LegalContext';

const { TextArea } = Input;
const { Option } = Select;

const EditLegalForm = props => {
  const { editLegal, response, setResponse } = useContext(LegalContext);
  const { modalVisible, setModalVisible, modal, selectedDoc } = props;
  const [validationError, setValidationError] = useState({});
  const [loading, setLoading] = useState(false);

  const { getFieldDecorator, getFieldError } = props.form;

  const nameError = getFieldError('name') || validationError.name;
  const termsError = getFieldError('terms') || validationError.terms;
  const languageError = getFieldError('language') || validationError.language;
  const requiredError = getFieldError('required') || validationError.required;

  const closeModal = () => {
    setValidationError({});
    setModalVisible(false);
    props.form.resetFields();
  };

  const handleOk = () => {
    setLoading(true);
    props.form.validateFields((error, values) => {
      if (error) {
        setLoading(false);
        return;
      }

      editLegal(values, selectedDoc.id);
    });
  };

  const handleCancel = () => {
    setResponse({});
    setLoading(false);
    closeModal();
  };

  const handleChange = e => {
    const eventTarget = e.target;
    const currentValidation = { ...validationError };

    if (eventTarget) {
      const fieldName = eventTarget.name;
      currentValidation[fieldName] = undefined;
    } else {
      currentValidation.language = undefined;
    }

    if (validationError) {
      setValidationError(currentValidation);
    }
  };

  useEffect(() => {
    if (response.errors) {
      setValidationError(response.errors);
    } else {
      setValidationError({});
    }

    if (response.id) {
      closeModal();
    }

    if (Object.entries(response).length !== 0) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  if (modal === 'edit') {
    return (
      <Modal
        title={`Edit ${selectedDoc.name}`}
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <Form layout="vertical" onSubmit={handleOk}>
          <Form.Item
            label="Name"
            validateStatus={nameError ? 'error' : ''}
            help={nameError || ''}
          >
            {getFieldDecorator('name', {
              initialValue: selectedDoc.name,
              rules: [
                { required: true, message: 'Please input a document name!' }
              ],
              onChange: e => handleChange(e)
            })(<Input name="name" placeholder="Name" />)}
          </Form.Item>
          <Form.Item
            label="Terms"
            validateStatus={termsError ? 'error' : ''}
            help={termsError || ''}
          >
            {getFieldDecorator('terms', {
              initialValue: selectedDoc.terms,
              rules: [
                { required: true, message: 'Please input a terms content!' }
              ],
              onChange: e => handleChange(e)
            })(<TextArea rows={20} name="terms" placeholder="Terms" />)}
          </Form.Item>
          <Form.Item
            label="Language"
            validateStatus={languageError ? 'error' : ''}
            help={languageError || ''}
          >
            {getFieldDecorator('language', {
              initialValue: selectedDoc.language ? selectedDoc.language : null,
              rules: [{ required: true, message: 'Please select a language!' }],
              onChange: e => handleChange(e)
            })(
              <Select
                name="language"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Language"
              >
                <Option key={'en'} value={'en'}>
                  EN
                </Option>
                <Option key={'de'} value={'de'}>
                  DE
                </Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item
            validateStatus={requiredError ? 'error' : ''}
            help={requiredError || ''}
          >
            {getFieldDecorator('required', {
              initialValue: selectedDoc.required,
              valuePropName: 'checked',
              onChange: (e) => handleChange(e)
            })(<Checkbox name="required">Required</Checkbox>)}
          </Form.Item>
        </Form>
      </Modal>
    );
  } else {
    return null;
  }
};

const EditLegal = Form.create()(EditLegalForm);

export default EditLegal;
